<script>

import { fly } from 'svelte/transition';
import { loans } from './stores.js';
import { calculateRealCost } from './loancalc.js'

function clearSpending() {
    spending = "";
}

function updateSpendingByValue(val) {
    return function () {
        if (spending === '0') {
            spending = '';
        }
        if (spending.length > 7 && !spending.includes('.')) {
            return;
        }
        if (val === '.' && spending.includes('.')) {
            return;
        }
        if (spending.includes('.') && spending.split('.')[1].length > 1) {
            return;
        }
        spending = "" + spending + val;
        spending.split('.')
    }
}

function shortenValue() {
    spending = spending.substr(0, spending.length - 1);
    if (spending.length === 0) {
        spending = "0"
    }
}

let spending = "0";
$: amount = calculateRealCost(spending, $loans);

</script>

<div>
    <div class="has-text-centered has-text-weight-bold">
        <div class="columns is-mobile">
            <div class="column amount">
                <h1 class="title is-huge">${spending}</h1>
            </div>
        </div>
        {#if spending != "0"}
        <div transition:fly="{{y: 100, duration: 300}}">
            <div class="columns is-mobile mb-0">
                <div class="column amount">
                    <h5 class="title is-5">actually costs</h5>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column amount">
                    <h1 class="title is-1">${amount}</h1>
                </div>
            </div>
        </div>
        {/if}
        <div class="is-size-3">
            <div class="columns is-unselectable is-mobile is-centered">
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(1)}">1</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(2)}">2</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(3)}">3</div>
            </div>
            <div class="columns is-unselectable is-mobile is-centered">
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(4)}">4</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(5)}">5</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(6)}">6</div>
            </div>
            <div class="columns is-unselectable is-mobile is-centered">
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(7)}">7</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(8)}">8</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(9)}">9</div>
            </div>
            <div class="columns is-unselectable is-mobile is-centered">
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue('.')}">.</div>
                <div class="column is-narrow mx-5" on:click="{updateSpendingByValue(0)}">0</div>
                <div class="column is-narrow mx-5" on:click="{shortenValue}">&lt;</div>
            </div>
        </div>
    </div>
</div>

<style>
    .amount {
        color: #4a614b;
    }
    .is-huge {
        font-size: 5rem;
    }
</style>
